import {
  FormControl,
  Heading,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ButtonGroup,
  Box,
} from "@chakra-ui/react";
import { Fragment, useEffect, useState } from "react";
import { BuilderTabs } from "../../FormBuilderTypes";
import InputGenerator from "./InputGenerator";

type PreviewProps = {
  tabs: BuilderTabs[];
  isOpen: boolean;
  onClose: () => void;
  // setTabs: any;
};

const FormPreview = ({ tabs: initialTabs, isOpen, onClose }: PreviewProps) => {
  const [index, setIndex] = useState(0);
  const [updatedTabs, setUpdatedTabs] = useState(initialTabs.filter((tab) => tab.linkedToOption !== true));
  const prev = () => {
    if (index !== 0) setIndex(index - 1);
  };

  const next = () => {
    if (!(index > updatedTabs.length - 1)) setIndex(index + 1);
  };

  useEffect(() => {
    const update = initialTabs.filter((tab) => tab.linkedToOption !== true)
    setUpdatedTabs([...update])
  },[initialTabs])

  const handleBuilders = (
    tabId: string,
    newBuilder: any,
    builderId: string
  ) => {
    setUpdatedTabs((prevTabs) => {
      return prevTabs.map((res) => {
        if (res.id === tabId) {
          const oldBuilder = res.builders.filter((b) => b.linkedTo === builderId);
          if (oldBuilder.length) {
            const idsToRemove = oldBuilder.map((item) => item.id);
            res.builders = res.builders.filter((item) => !idsToRemove.includes(item.id)) 
          }
          const insertIndex = res.builders.findIndex((res) => res.id === builderId) + 1;
          if (newBuilder && newBuilder.length) {
            return {
              ...res,
              builders: [
                ...res.builders.slice(0, insertIndex),
                ...newBuilder.map((b: any) => ({ ...b, linkedTo: builderId })),
                ...res.builders.slice(insertIndex),
              ],
            };
          }
        }
        return res;
      });
    });
  };
  

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onClose();
        setIndex(0);
        setUpdatedTabs(initialTabs.filter((tab) => tab.linkedToOption !== true))
      }}
      size="4xl"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Form Preview</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <Fragment key={`${updatedTabs[index]?.id}${updatedTabs[index]?.name}`}>
              <Heading as="h4" size="md" mb={"4"}>
                {updatedTabs[index]?.name}
              </Heading>
              {updatedTabs[index]?.builders.map((builder) => (
                <Box key={`${builder.id}${updatedTabs[index]?.name}`} w={"100%"}>
                  <InputGenerator
                    builder={builder}
                    handleBuilders={handleBuilders}
                    tabId={updatedTabs[index].id}
                  />
                </Box>
              ))}
            </Fragment>
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <ButtonGroup>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={prev}
              disabled={index === 0}
            >
              Previous
            </Button>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={next}
              disabled={updatedTabs.length < 1 || updatedTabs.length - 1 <= index}
            >
              Next
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default FormPreview;
